<template>
    <div class="portal" v-if="load">
        <div class="portal_bg">
            <div class="portal_btn_list">
                <div style="color: white; font-size: min(11.2vw, 90px); margin-bottom: 15px; font-weight: bold;"> 游戏大厅
                </div>
                <div class="portal_btn" v-for="item in list" :key="item.id" @click="toggleCheck(item.gameType)">
                    <button type="button" class="van-button van-button--primary van-button--normal"
                        style="color: white; background: rgb(160, 47, 51); border-color: rgb(160, 47, 51); width: 66vw; max-width: 486px; height: 6.41872vh; font-weight: bold; font-size: x-large;">
                        <div class="van-button__content"><!----><span
                                class="van-button__text">{{ item.name }}</span><!----></div>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div id="loader-wrapper" v-else>
        <div id="loader" v-if="!isToast"></div>
        <div class="loader-section section-left" v-if="!isToast"></div>
        <div class="loader-section section-right" v-if="!isToast"></div>
        <div class="load_title">{{title}}</div>
    </div>

</template>

<script>
    import {
        checkData
    } from '@/api/home'
    export default {
        name: 'Auth',
        data() {
            return {
                title: '正在加载应用，请耐心等待',
                list: [],
                load: true,
                isToast: false
            }
        },
        async created() {
            var that = this;
            var uu = window.localStorage.getItem('token');
            const data = await checkData(uu, 9999999);
            if (data.status == 200) {
                window.localStorage.setItem('userToken', data.user.token);
                this.list = data.game
                document.title = data.title ?? '财神';
                setTimeout(function() {
                    that.load = true;
                }, 300);
            } else {
                this.title = data.message
                this.isToast = true
            }
        },
        methods: {
            async toggleCheck(type) {
                var uu = window.localStorage.getItem('token');
                const data = await checkData(uu, type);
                if (data.status == 200) {
                    this.$router.push('/home')
                } else {
                    this.$dialog.alert({
                        message: data.message,
                    }).then(() => {});
                }
            }
        }
    }
</script>

<style>
    html,
    body,
    #app {
        height: 100%;
        margin: 0;
        padding: 0;
    }

    .chromeframe {
        margin: .2em 0;
        background: #ccc;
        color: #000;
        padding: .2em 0
    }

    #loader-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999999
    }

    #loader {
        display: block;
        position: relative;
        left: 50%;
        top: 40%;
        width: 150px;
        height: 150px;
        margin: -75px 0 0 -75px;
        border-radius: 50%;
        border: 3px solid transparent;
        border-top-color: #1989fa;
        -webkit-animation: spin 2s linear infinite;
        -ms-animation: spin 2s linear infinite;
        -moz-animation: spin 2s linear infinite;
        -o-animation: spin 2s linear infinite;
        animation: spin 2s linear infinite;
        z-index: 1001
    }

    #loader:before {
        content: "";
        position: absolute;
        top: 5px;
        left: 5px;
        right: 5px;
        bottom: 5px;
        border-radius: 50%;
        border: 3px solid transparent;
        border-top-color: #1989fa;
        -webkit-animation: spin 3s linear infinite;
        -moz-animation: spin 3s linear infinite;
        -o-animation: spin 3s linear infinite;
        -ms-animation: spin 3s linear infinite;
        animation: spin 3s linear infinite
    }

    #loader:after {
        content: "";
        position: absolute;
        top: 15px;
        left: 15px;
        right: 15px;
        bottom: 15px;
        border-radius: 50%;
        border: 3px solid transparent;
        border-top-color: #1989fa;
        -moz-animation: spin 1.5s linear infinite;
        -o-animation: spin 1.5s linear infinite;
        -ms-animation: spin 1.5s linear infinite;
        -webkit-animation: spin 1.5s linear infinite;
        animation: spin 1.5s linear infinite
    }

    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0);
            -ms-transform: rotate(0);
            transform: rotate(0)
        }

        100% {
            -webkit-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            transform: rotate(360deg)
        }
    }

    @keyframes spin {
        0% {
            -webkit-transform: rotate(0);
            -ms-transform: rotate(0);
            transform: rotate(0)
        }

        100% {
            -webkit-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            transform: rotate(360deg)
        }
    }

    #loader-wrapper .loader-section {
        position: fixed;
        top: 0;
        width: 51%;
        height: 100%;
        background: #fff;
        z-index: 1000;
        -webkit-transform: translateX(0);
        -ms-transform: translateX(0);
        transform: translateX(0)
    }

    #loader-wrapper .loader-section.section-left {
        left: 0
    }

    #loader-wrapper .loader-section.section-right {
        right: 0
    }

    .loaded #loader-wrapper .loader-section.section-left {
        -webkit-transform: translateX(-100%);
        -ms-transform: translateX(-100%);
        transform: translateX(-100%);
        -webkit-transition: all .7s .3s cubic-bezier(.645, .045, .355, 1);
        transition: all .7s .3s cubic-bezier(.645, .045, .355, 1)
    }

    .loaded #loader-wrapper .loader-section.section-right {
        -webkit-transform: translateX(100%);
        -ms-transform: translateX(100%);
        transform: translateX(100%);
        -webkit-transition: all .7s .3s cubic-bezier(.645, .045, .355, 1);
        transition: all .7s .3s cubic-bezier(.645, .045, .355, 1)
    }

    .loaded #loader {
        opacity: 0;
        -webkit-transition: all .3s ease-out;
        transition: all .3s ease-out
    }

    .loaded #loader-wrapper {
        visibility: hidden;
        -webkit-transform: translateY(-100%);
        -ms-transform: translateY(-100%);
        transform: translateY(-100%);
        -webkit-transition: all .3s 1s ease-out;
        transition: all .3s 1s ease-out
    }

    .no-js #loader-wrapper {
        display: none
    }

    .no-js h1 {
        color: #222
    }

    #loader-wrapper .load_title {
        font-family: 'Open Sans';
        color: #1989fa;
        font-size: 19px;
        width: 100%;
        text-align: center;
        z-index: 9999999999999;
        position: absolute;
        top: 55%;
        opacity: 1;
        line-height: 30px
    }

    #loader-wrapper .load_title span {
        font-weight: 400;
        font-style: italic;
        font-size: 13px;
        color: #fff;
        opacity: .5
    }

    .portal {
        width: 100%;
        height: 100%;
        background-color: #082f50
    }

    .portal_bg {
        background: url(/src/assets/bg6.jpg) center center;
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        overflow: auto;
        /* padding-top: 8%; */
    }

    .portal_btn_list {
        width: 100%;
        text-align: center;
        /* position: absolute; */
        /* top: 5%; */
        /* min-height: 100vh; */
        height: 92%;
        margin-top: 8%;
    }

    .portal_btn {
        padding: 5px
    }

    .portal_btn a {
        color: #fff;
        text-decoration: none;
        line-height: 6.3vh;
        font-weight: 700;
        font-size: 3vh
    }
</style>
